/** Word-level IPA overrides for French. */
export const fr: Record<string, string> = {
  conflans: '/kɔ̃flɑ̃/', // place name
  est: '/ɛ/', // verb "is" — st is silent (dict has /ɛst/)
  jolies: '/ʒɔli/',
  luit: '/lɥi/',
  marchiennes: '/maʁʃjɛn/', // place name (Zola)
  'métaphysico-théologo-cosmolonigologie': '/metafizikoteolɔɡɔkɔsmɔlɔniɡɔlɔʒi/', // Voltaire
  montsou: '/mɔ̃su/', // fictional town (Zola)
  morgion: '/mɔʁʒjɔ̃/', // place name (Dumas)
  myriel: '/miʁjɛl/', // character name (Hugo)
  'neuve-sainte-geneviève': '/nœvsɛ̃tʒənvjɛv/', // Paris street (Balzac)
  nicole: '/nikɔl/',
  pangloss: '/pɑ̃ɡlɔs/', // Voltaire character
  rainurée: '/ʁɛnyʁe/',
  rion: '/ʁjɔ̃/', // place name (Dumas)
  'saint-marcel': '/sɛ̃maʁsɛl/', // Paris quarter (Dumas)
  'thunder-ten-tronckh': '/tɔnɛʁtɛntʁɔnk/', // Voltaire
  trieste: '/tʁijɛst/', // city name (Dumas)
  vauquer: '/voke/', // character name (Balzac)
  y: '/i/', // pronoun "there" — dict has letter name /igʁɛk/
};
